import { render, staticRenderFns } from "./FoodcourtChangeStatus.vue?vue&type=template&id=1870e6ba"
import script from "./FoodcourtChangeStatus.vue?vue&type=script&lang=js"
export * from "./FoodcourtChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtChangeStatus.vue?vue&type=style&index=0&id=1870e6ba&prod&lang=scss"
import style1 from "./FoodcourtChangeStatus.vue?vue&type=style&index=1&id=1870e6ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports